export const TAG_GROUPS = {
  FROM_CSV: 'TAG_FROM_CSV',
} as const
